<template>
  <div class="modal-header">
    <div class="header-right">
      <MaskIcon src="/img/information1.svg" class="modal-info-icon" alt="info" role="button" tabindex="0" />
      <div class="modal-title">
        <slot></slot>
      </div>
    </div>
    <div class="header-left">
      <slot name="actions" />
    </div>
  </div>
</template>

<!-- script removed: props not required, the component uses slots for title -->
<script setup>
import MaskIcon from '@/components/MaskIcon.vue';
</script>

<style scoped>
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin: 10px; /* add 10px margin to modal header */
}
.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.modal-info-icon {
  width: 20px;
  height: 20px;
  display: inline-block;
  color: var(--text-color-secondary);
}
.modal-title h3,
.modal-title {
  margin: 0;
  display: inline-flex;
  align-items: center;
  cursor: default; /* prevent pointer cursor on the modal title text */
}
.header-left {
  display: flex;
  gap: 8px;
}
</style>
